import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: column;

    .radioGroup {
        flex-grow: 1;
        justify-content: space-between;

        label {
            margin-top: 0;
            width: 100% !important;
            max-width: 100% !important;
            margin-bottom: 15px;

            &:nth-child(3n) {
                margin-right: 0;
            }

            @media (max-width: 700px) {
                flex: calc(50% - 10px);
                max-width: calc(50% - 10px);

                &:nth-child(3n) {
                    margin-right: 15px;
                }

                &:nth-child(2n) {
                    margin-right: 0;
                }
            }

            @media (max-width: 480px) {
                flex: 100%;
                max-width: 100%;
                margin-right: 0;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                &:nth-child(2n) {
                    margin-right: 0;
                }
            }
        }
    }

    .reusecore__button {
        flex: calc(33.3333333333% - 10px);
        max-width: calc(33.3333333333% - 10px);
        flex-shrink: 0;
        height: auto;
        min-height: 77px;
        border: 1px dashed ${themeGet("colors.borderColor", "#f1f1f1")};
        margin-bottom: 15px;
        margin-left: 0;
        margin-right: auto;

        &:hover {
            border-color: ${themeGet("colors.primary", "#9cc54b")};
        }

        @media (max-width: 700px) {
            flex: calc(50% - 10px);
            max-width: calc(50% - 10px);
        }

        @media (max-width: 480px) {
            flex: 100%;
            max-width: 100%;
        }
    }
`;

export const HelpPageWrapper = styled.div`
    background-color: #f7f7f7;
    position: relative;
    padding: 50px 0 50px 0;
    min-height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    table th {
        // width: 0.8em;
    }

    table th.sortable {
        cursor: pointer;
    }

    @media (max-width: 989px) {
        padding-top: 70px;
    }
`;

export const TableBodyWidth = styled.div`
    table tr th {
        white-space: nowrap;
        width: initial;
    }
`;

export const MuiTableStyle = styled.div`
    table {
        thead tr th {
            width: initial;
            vertical-align: middle;
            font-weight: 700;
            font-size: 0.95rem;
            background: #efefef;
        }

        tbody tr td {
            vertical-align: middle;
            white-space: nowrap;
            font-size: 0.95rem;
        }
    }

    .MuiDialogContent-dividers {
        padding: 1rem;
    }

    .MuiTableContainer-root {
        ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            border-radius: 3px;
        }

        ::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 6px;

            &:hover {
                background: #555;
            }
        }
    }
`;

export const labelStyle = {
	lineHeight: "2.5rem",
};
